var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_228_104)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4558 34.9625C40.832 34.6521 37.7736 33.1563 37.2042 32.948C36.6348 32.7417 36.2204 32.6396 35.8038 33.2605C35.3893 33.8771 34.1982 35.273 33.836 35.6855C33.4718 36.1 33.1096 36.15 32.4879 35.8417C31.8662 35.5292 29.8607 34.8771 27.4848 32.7688C25.6363 31.1271 24.3866 29.1 24.0244 28.4792C23.6623 27.8605 23.9847 27.525 24.2966 27.2167C24.5771 26.9396 24.9183 26.4938 25.2302 26.1334C25.5421 25.7709 25.6447 25.5126 25.8519 25.098C26.0613 24.6855 25.9566 24.3251 25.7996 24.0146C25.6447 23.7042 24.4013 20.6563 23.8821 19.4167C23.3776 18.2105 22.8647 18.3751 22.4837 18.3542C22.1195 18.3376 21.705 18.3334 21.2905 18.3334C20.876 18.3334 20.202 18.4876 19.6326 19.1084C19.0611 19.7271 17.4555 21.2251 17.4555 24.273C17.4555 27.3188 19.6828 30.2625 19.9947 30.6771C20.3066 31.0896 24.3803 37.3438 30.6206 40.025C32.1069 40.6625 33.2645 41.0438 34.1668 41.3271C35.6572 41.8 37.0137 41.7334 38.0855 41.5729C39.2788 41.3959 41.7657 40.075 42.2848 38.6292C42.8019 37.1834 42.8019 35.9438 42.647 35.6855C42.4921 35.4271 42.0776 35.273 41.4538 34.9625H41.4558ZM30.1057 50.3854H30.0973C26.3908 50.3861 22.7525 49.3945 19.5635 47.5146L18.8099 47.0688L10.9765 49.1146L13.0678 41.5146L12.5759 40.7354C10.5037 37.4528 9.40714 33.6537 9.4128 29.7771C9.41699 18.423 18.6989 9.1855 30.114 9.1855C35.6405 9.1855 40.8362 11.3313 44.7424 15.223C46.6691 17.1325 48.1962 19.4033 49.2353 21.904C50.2745 24.4047 50.8051 27.0856 50.7964 29.7917C50.7922 41.1459 41.5103 50.3854 30.1057 50.3854ZM47.715 12.2667C45.4085 9.95617 42.6642 8.12412 39.6411 6.87675C36.618 5.62938 33.3762 4.99151 30.1036 5.00009C16.3837 5.00009 5.21352 16.1147 5.20934 29.775C5.20298 34.1224 6.34891 38.3946 8.5315 42.1604L5 55L18.1965 51.5542C21.8471 53.5336 25.938 54.5707 30.0952 54.5708H30.1057C43.8255 54.5708 54.9957 43.4563 54.9999 29.7938C55.01 26.5381 54.3714 23.3128 53.1209 20.3043C51.8705 17.2958 50.0331 14.564 47.715 12.2667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_228_104",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_228_104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_228_104",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/WhatsApp.f9bf7318c673006750cb91f13526dc92.svg";
export { ForwardRef as ReactComponent };